import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TaskComponent } from '../../@commons/@components/task/task.component';
import { SharedModule } from '../../@commons/ui-components/shared.module';
import { ArticleComponent } from '../../@commons/@components/article/article.component';
import { TaskApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/task/task-api';
import {
  TaskListRequest
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/location/task-list.request';
import { StorageService } from '../../@commons/@services/front/storage.service';
import {
  TaskListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/task-list.response';
import { ArticleListRequest } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/article/article-list.request';
import { ArticleApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/article/article-api';

@Component({
    selector: 'vw-agenda-task', // Indicates the component is standalone
    imports: [CommonModule, SharedModule, TranslateModule, TaskComponent, ArticleComponent], // Modules required by this component
    templateUrl: './agenda-task.component.html', // HTML template for the component
    styleUrl: './agenda-task.component.scss', // Stylesheet for the component
    providers: [{
            provide: TaskApi,
            useClass: TaskApi
        }, {
            provide: ArticleApi,
            useClass: ArticleApi
        }]
})
export class AgendaTaskComponent {
  tasks: TaskListResponse[] = [];
  articles: any[] = []; // Array to hold badge information
  isLoading: boolean = false;

  /**
   * ID of the currently active task.
   * @type {number | null}
   */
  activeTaskId: number | null = null;

  /**
   * List of advices related to the agenda.
   * @type {any[]}
   */
  advices: any[] = [];

  /**
   * Initializes the AgendaTaskComponent with required services.
   * @param {TaskApi} taskApi - Service to fetch agenda-related data
   */
  constructor(private taskApi: TaskApi, private storageService: StorageService, private articleApi: ArticleApi) { }

  async ngOnInit() {
    this.isLoading = true;
    try {
      this.loadTasks();
      await this.loadArticles();
    } catch (e) {
      console.error('AgendaTaskComponent: failed to initialize', e);
    } finally {
      this.isLoading = false;
    }
  }

  loadTasks() {
    const listTasksRequest = new TaskListRequest();
    return this.taskApi.list(listTasksRequest, 0, 20, this.storageService.getCurrentLanguage())
      .then((response) => {
        this.tasks = response.results;
      })
      .catch((e) => console.error('AgendaTaskComponent: failed to load tasks', e));
  }

  async loadArticles() {
    const articles = await this.articleApi.list(new ArticleListRequest(), 1, 20, this.storageService.getCurrentLanguage());
    this.articles = articles.results;
  }
}
